import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../api/auth';
import { WORDS } from '../constants/words';
import { LEARNING_CARDS_ROUTES } from '../constants/learning-cards';

function LearningCardsPage() {
    const [authenticated, setAuthenticated] = useState(isAuthenticated());

    useEffect(() => {
        setAuthenticated(isAuthenticated());

        const handleStorageChange = () => {
            setAuthenticated(isAuthenticated());
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    if (authenticated) {
        return <Navigate to={LEARNING_CARDS_ROUTES.GROUPS} replace />;
    }

    return (
        <div className="page-section">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>{WORDS.LEARNING_CARDS_SERVICE}</h2>
            </div>

            <div className="card mb-4">
                <div className="card-body text-center py-5">
                    <h3 className="card-title mb-3">Welcome to Flashcards!</h3>
                    <p className="card-text mb-4">
                        Create and manage your own flashcard collections to help with memorization.
                        Perfect for language learning, studying, or anything you want to remember.
                    </p>
                    <p className="card-text mb-4">
                        Please log in to create and access your flashcards.
                    </p>
                    <button
                        className="btn btn-primary btn-lg"
                        onClick={() => {
                            document.querySelector('.navbar .btn-outline-primary').click();
                        }}
                    >
                        Login to Get Started
                    </button>
                </div>
            </div>

            <div className="card mb-4">
                <div className="card-header">Features</div>
                <div className="card-body">
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item">Create personalized flashcard groups</li>
                        <li className="list-group-item">Test your knowledge with practice sessions</li>
                        <li className="list-group-item">Track your learning progress</li>
                        <li className="list-group-item">Perfect for learning Japanese or any other language</li>
                        <li className="list-group-item">Share your flashcard collections with others</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default LearningCardsPage;